import Card from "antd/lib/card";
import Meta from "antd/lib/card/Meta";
import TryWithAi from "./trywithai.svg";
import "./index.less";
import { ZIcon } from "@atoms";
import { EIcons } from "@atoms/ZIcon/interface";
import { EColors } from "@atoms/ZColors/interface";
import React from "react";
import { IZTryWithAiCardProps } from "./interface";

const ZTryWithAiCard: React.FC<IZTryWithAiCardProps> = ({
	onClose,
	className,
	onMouseOver,
	onMouseOut
}) => {
	return (
		<div
			className={`z-try-with-ai-card-container ${className}`}
			onMouseOver={onMouseOver}
			onMouseOut={onMouseOut}
		>
			<ZIcon
				onClick={onClose}
				name={EIcons.CLOSE}
				fill
				color={EColors.GRAY}
				colorVariant={1}
				size="sm"
				className="z-try-with-ai-card-close"
			/>
			<Card
				style={{ width: 261 }}
				cover={<TryWithAi />}
				className="z-try-with-ai-card"
			>
				<Meta
					title="Try custom field with AI"
					description="Start creating custom fields with AI"
				/>
			</Card>
		</div>
	);
};

export default ZTryWithAiCard;
